import { render } from "./BlogAllxAdditionalAdhesives.vue?vue&type=template&id=cd8aab00"
import script from "./BlogAllxAdditionalAdhesives.vue?vue&type=script&lang=js"
export * from "./BlogAllxAdditionalAdhesives.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__